export interface User {
    uid: string;
    displayName: string;
    email: string;
    accessLevel?: number;
    events: string[] | null; //array of all event id's the user is in
    conferenceCode: string | null;
    ticketClass: string | null;
    transactionId: string[] | null;
    paymentTime: Date | null;
    formSubmitted: boolean;
    products: Record<string, number>; // productId: quantity
};

export interface Payment {
    type: "paypal"|"helcim"|"free";
    amount: number;
    transactionId: string;
    item: string;
    uid: string;
    dateCreated: Date;
    customerCode: string|null; // this can be null only for free tickets
};

export type QuestionFormat = "oneline" | "multiline" | "date" | "number" | "email" | "hline" | "multiplechoice";

export interface Question {
    id: string;
    index: number;
    question: string;
    format: QuestionFormat;
    properties?: {
        maxlines?: number;
        maxchars?: number;
        required?: boolean;
        [key: string]: any;
    };
}

export interface Conference {
    conferenceCode: string;
    conferenceName: string;
    prices: Record<string, number>;
}

export interface Product {
    id: string;
    name: string;
    price: number;
    imageUrl: string;
    description: string | null;
    isActive: boolean; 
}


export interface Day {
    id: string;
    date: string | null;
    events: Event[];
    isEditing?: boolean;
    isDeleted?: boolean;
    deletedEvents?: Event[];
}

export interface Location {
    name: string;
    lat: number;
    lng: number;
}

export interface Event {
    id: string;
    name: string;
    start: string;
    end: string;
    location: Location | null;
    link: string | null;
    speaker: string | null;
    speakerTitle: string | null;
    assignedIDs: string[];
}

// Interface for bulk assignment
export interface Assignment {
    email: string;
    eventIds: string[];
    eventNames: string[] | undefined;
    status: 'valid' | 'invalid';
    error?: string;
}

export const generateUUID = () => {
    const length = 20;
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let randomString = '';

    for (let i = 0; i < length; i++) {
        randomString += characters.charAt(array[i] % charactersLength);
    }

    return randomString;
}